"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTypeEnum = void 0;
var ExternalTypeEnum;
(function (ExternalTypeEnum) {
    ExternalTypeEnum["Investown"] = "investown";
})(ExternalTypeEnum = exports.ExternalTypeEnum || (exports.ExternalTypeEnum = {}));
//# sourceMappingURL=external-type-enum.js.map